/* 
  Empty Javascript file generated By App
  Caution: Don't delete this file
*/

























































































































































































































/** RE- Coded by Aaliyan Gul (ishopifyexpert) **/
window.translationsText = window.translationsText || {}; window.translationsText.stickyFilled = $('.product-form-customizer').data('stickybuttonstarttext');window.translationsText.buttonUnfilled = $('.product-form-customizer').data('buttontext');window.translationsText.farbe = 'Löffel'; if($('body').hasClass('pr-on-inventory-modified') || $('body').hasClass('pr-on-premium-inventory-modified')){ window.translationsText.buttonUnfilled = 'Choose your styles';window.translationsText.stickyFilled = $('.product-form-customizer').data('stickybuttonsuccesstext');window.translationsText.farbe = 'Style';}
function setProgressBar(total, filled) {const progressBarFill = document.querySelector('.progress-bar-fill');const percentage = (filled / total) * 100;progressBarFill.style.width = `${percentage}%`;$('.spoon-selection__selection-container .spoon-selection__grid .spoon-selection__image').removeClass('bk-border');$('.spoon-selection__selection-container .spoon-selection__grid .spoon-selection__image:not(.coladded)').first().addClass('bk-border'); }
function updateProgress(){ var totalFilledSpoon = $('.hidden-spoon[value!=""]').length;var totalToBeFilled = parseInt($('#pick-spoon-id').attr('custom-toshow')); setProgressBar(totalToBeFilled,totalFilledSpoon); $('.greyedText .selectedSpoon').text(totalFilledSpoon); if (totalFilledSpoon == totalToBeFilled) { $('.hidden-overlay').click();$('#AddToCart').removeAttr('disabled');$('.remover_upsell').removeAttr('disabled'); $('.template-product-nailkit').addClass('allfill');$('.custom-fixed-footer button').removeAttr('disabled');$('#StickyAddToCart').removeClass('disabled');$('#StickyAddToCart .loader-button__text').text(window.translationsText.stickyFilled); } else { $('#StickyAddToCart').addClass('disabled');$('#StickyAddToCart .loader-button__text').text($('#AddToCart .disabled-text').text());$('.template-product-nailkit').removeClass('allfill');setTimeout(function(){ $('#AddToCart').attr('disabled','true');$('.custom-fixed-footer button').attr('disabled','true'); },100); } }
$(document).ready(function(){ $('.spoon-selection__image--top').click(function(e) {
    e.preventDefault();e.stopPropagation();
    var count = $(this).closest('.spoon-selection__grid-item').data('count'); if($(this).closest('.spoon-selection__grid-item').hasClass('active')){$('.spoon-selection__grid-item.active').removeClass('active');$('.spoon-selection__selection-container').hide();$('body').removeClass('spoon-choose-active'); }
    else { $('.spoon-selection__grid-item.active').removeClass('active');$(this).closest('.spoon-selection__grid-item').addClass('active'); $(`.spoon-selection__selection-container`).css('display', 'flex');$('body').addClass('spoon-choose-active'); }
  });
  $('.spoon-selection__selection-grid-item.clickable').click(function(event) {
    if($(this).data('disable') == undefined) { $('.spoon-selection__selection-grid-item.clickable').attr('data-disable',true);var $file = $(this).children('.spoon-selection__image').data('file');var $spoonName = $(this).children('.spoon-selection__image').data('name');var $variantId = $(this).children('.spoon-selection__image').data('variant');var count = $('.hidden-spoon[value=""]:eq(0)').data('spoon-index'); //$(this).parent('.spoon-selection__selection-container').data('count');
      var totalCount = $('.spoon-selection__grid-item').data('total-count');var $input = $(`#spoon${count}`); var $img = $(`.spoon-selection__grid-item[data-count=${count}]`).children('.spoon-selection__image--top');var $title = $(`.spoon-selection__grid-item[data-count=${count}]`).children('.farbe-title'); $(`.spoon-selection__grid-item[data-count=${count}]`).children('.spoon-selection__image--top').find('.spoon-selection-ad-text').remove();$input.val($spoonName);$input.attr('variant-id',$variantId); $input.attr('variant-img',$file);$img.css('backgroundImage', `url(${$file})`); $title.text($spoonName);$img.addClass('coladded');updateProgress();setTimeout(function(){ $('.spoon-selection__selection-grid-item.clickable').removeAttr('data-disable');},50); } else { event.stopPropagation(); }
  });
  $('#StickyAddToCart').click(function(ev){
    ev.preventDefault();ev.stopPropagation(); ev.stopImmediatePropagation();
    $('html, body').animate({
    scrollTop: $(".product__info form.shopify-product-form").offset().top - 50
  }, 750);
  setTimeout(function(){$('#MainPaymentContainer').trigger('click')},650);
    //if($(this).hasClass('disabled')){  }
  });
  $('body').on('click','#MainPaymentContainer',function(evt){ if($(this).find('#AddToCart').attr('disabled') == 'disabled') {evt.preventDefault();evt.stopImmediatePropagation();$('.spoon-selection__image.spoon-selection__image--top.pi-1').trigger('click'); }; });
  $('.spoon-choose-filter').click(function(evt){evt.preventDefault();evt.stopImmediatePropagation(); $(this).parents('.spoon-selection__selection-container').find('.spoon-choose-filter').removeClass('text--underlined');$(this).addClass('text--underlined');let offSet = ($(this)[0].offsetLeft);$('.spoon-filter-link-bar .link-bar__scroller').animate({ scrollLeft: ($(this).position().left + $('.spoon-filter-link-bar .link-bar__scroller').scrollLeft()) - 100 }, 500); var filterVal = $(this).data('tag'); $(this).parents('.spoon-selection__selection-container').find('.spoon-selection__selection-grid-item.clickable').hide().filter('.' + filterVal).show(); }); $('body').on('click','.custom-new-upsell',function(evt){ if($(this).find('.remover_upsell').attr('disabled') == 'disabled'){ evt.preventDefault();evt.stopImmediatePropagation();$('.spoon-selection__image.spoon-selection__image--top.pi-1').trigger('click'); } });$('.spoon-selection__arrow.close_icon_svg').click(function(evt){evt.preventDefault();evt.stopImmediatePropagation();var $parent = $(this).parents('.spoon-selection__grid-item'); var count = $parent.data('count');var totalCount = $('.spoon-selection__grid-item').data('total-count'); var $input = $(`#spoon${count}`);var $img = $(`.spoon-selection__grid-item[data-count=${count}]`).children('.spoon-selection__image--top');$(`.spoon-selection__grid-item[data-count=${count}]`).children('.farbe-title').text(`${window.translationsText.farbe} ${count}`);$input.val(''); $input.removeAttr('variant-id');$input.removeAttr('variant-img');$img.removeAttr('style');$img.removeClass('coladded');updateProgress()}); document.addEventListener('variant:changed', function(event) { updateProgress(); }); $('.spoon_choose_arrow').click(function(){ let scroll = 100; if($(this).hasClass('prev-arrow')) scroll *= -1; $('.spoon-filter-link-bar .link-bar__scroller').animate({ scrollLeft: ($('.spoon-filter-link-bar .link-bar__scroller').scrollLeft() + scroll ) }, 500); }); $("body").click(function(event){ if( !$(event.target).is('.spoon_choose_arrow')&&!$(event.target).is('.spoon-selection__selection-grid-item')&&!$(event.target).is('.spoon-selection__selection-grid-item *')&&!$(event.target).is('.link-bar .container')&&!$(event.target).is('.link-bar')&&!$(event.target).is('.link-bar__linklist')&&!$(event.target).is('.link-bar__scroller')&&!$(event.target).is('.link-bar__link-item')&& !$(event.target).is('.spoon-choose-filter')&&!$(event.target).is('.spoon-selection__image--top') &&!$(event.target).is('#MainPaymentContainer .disabled-text') &&!$(event.target).is('#MainPaymentContainer #AddToCart')  && !$(event.target).is('.spoon-selection-pi-text') && !$(event.target).is('.spoon-tool-tip') ){ $('.spoon-selection__grid-item.active').removeClass('active');$('.spoon-selection__selection-container').hide(); $('body').removeClass('spoon-choose-active'); } }); setProgressBar(parseInt($('#pick-spoon-id').attr('custom-toshow')),$('.hidden-spoon[value!=""]').length);$('#AddToCart').attr('disabled','true');$('#StickyAddToCart').addClass('disabled');$('#AddToCart').append(`<span class='disabled-text'>${window.translationsText.buttonUnfilled}</span>`);$('#StickyAddToCart .loader-button__text').text($('#AddToCart .disabled-text').text());
});





























































































